import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import {
    defaultState,
    EventCentreDialogState,
} from '../event-centre-dialog.state';
import { determineUnread } from '../function/determine-unread.function';
import { filterIsDefault } from '../function/filter-is-default.function';
import { filterItems } from '../function/filter-items.function';
import { categoryTransformer } from '../transformer/category.transformer';
import { itemTransformer } from '../transformer/item.transformer';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType.NOTI__EC__RELOAD, Reload>,
): EventCentreDialogState {
    const defState = defaultState();
    const nextState =
        action.payload.hard === 'reload' ? defState : { ...state };

    if (action.payload.hard === 'reload') {
        nextState.categories = categoryTransformer([]);
        nextState.categories = determineUnread(nextState.categories, []);
        nextState.navCategories = nextState.categories.slice(1);
        nextState.items = [];
        nextState.seenItems = [];
    }

    const nextCatId =
        action.payload.categoryId ??
        nextState.navCategories?.[0]?.categoryId; /* yes, navCategories */
    const nextCat = nextState.categories?.find(
        (e) => e.categoryId === nextCatId,
    );

    let nextSearchOpen = state.searchOpen;
    let nextFiltOpts = state.filterOpts;
    let nextOrderBy = state.orderBy;
    if (action.payload.hard === 'filter') {
        nextSearchOpen = defState.searchOpen;
        nextFiltOpts = defState.filterOpts;
        nextOrderBy = defState.orderBy;
    }

    const nextFilt = filterItems({
        items: nextState.items,
        categoryId: nextCatId,
        filterOpts: nextFiltOpts,
        categories: state.categories,
        orderBy: nextOrderBy,
    });

    const nextFiltDef = filterIsDefault(nextFiltOpts);

    nextState.userId = action.payload.userId;
    nextState.categoryId = nextCatId;
    nextState.category = nextCat;
    nextState.searchOpen = nextSearchOpen;
    nextState.filterOpts = nextFiltOpts;
    nextState.filterIsDefault = nextFiltDef;
    nextState.orderBy = nextOrderBy;
    nextState.filteredItems = nextFilt;

    return nextState;
}

export function reloadResultReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType.NOTI__EC__RELOAD_RESULT, ReloadResult>,
): EventCentreDialogState {
    try {
        let nextCategories =
            action.payload.categories == null
                ? state.categories
                : categoryTransformer(action.payload.categories);
        nextCategories = determineUnread(nextCategories, action.payload.items);
        const nextNavCategories = nextCategories.slice(1);

        const nextItems = itemTransformer(
            action.payload.items,
            nextNavCategories,
        );

        const nextFilt = filterItems({
            items: nextItems,
            categoryId: state.categoryId,
            filterOpts: state.filterOpts,
            categories: nextCategories,
            orderBy: state.orderBy,
        });

        return {
            ...state,
            navCategories: nextNavCategories,
            categories: nextCategories,
            items: nextItems,
            filteredItems: nextFilt,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
